import { defineStore } from 'pinia';
import { fetchLoggedUser, logout as logoutApi } from "../services/auth";

const SESSION_KEY = 'userRaw';

export const useAuthStore = defineStore('Auth', {
  state: () => {
    const stored = sessionStorage.getItem(SESSION_KEY);
    return {
      userRaw: stored ? JSON.parse(stored) : null,
    };
  },
  getters: {
    isLoggedIn:  (state) => state.userRaw !== null,
    isAdmin:     (state) => state.userRaw?.isAdmin ?? false,
    id:          (state) => state.userRaw?.id ?? null,
    firstName:   (state) => state.userRaw?.firstName ?? null,
    userCompany: (state) => state.userRaw?.company ?? null,
  },
  actions: {
    async fetchLoggedUser() {
      this.userRaw = await fetchLoggedUser();
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(this.userRaw));
    },

    async logout() {
      try {
        await logoutApi();
        this.removeAuth();
        const { default: router } = await import('../router');
        router.push({ name: 'homepage' });
      } catch (error) {
        console.error('Logout failed:', error);
      }
    },

    removeAuth() {
      this.userRaw = null;
      sessionStorage.removeItem(SESSION_KEY);
    },
  },
});
